import { FC, ReactElement, ReactNode, useState } from "react";

interface UIAccordionProps {
	title: string;
	children: ReactNode;
	defaultOpen?: boolean;
}

export default function UIAccordion({
	title,
	children,
	defaultOpen
}: UIAccordionProps) {

	const [open, setOpen] = useState(defaultOpen || false);

	return (
		<div className="w-full">
			<div 
				onClick={() => setOpen(!open)}
				className={`flex items-center justify-between select-none cursor-pointer py-[20px] ${!open ? "border-b border-solid border-[#eaeaeae6]" : "" }`}>
					<h2 className="text-[18px] leading-[20px] font-medium">
						{title}
					</h2>
					<span
						className=""
					>
						{ open ? 
							<svg width="17" height="2" viewBox="0 0 17 2" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M17 7.43094e-07V1.3L0 1.3L5.68248e-08 8.74224e-08L17 7.43094e-07Z" fill="#2A2A2A"/>
							</svg> 
							:
							<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path fillRule="evenodd" clipRule="evenodd" d="M9.3 0H8V8H0V9.3H8V17H9.3V9.3H17V8H9.3V0Z" fill="#2A2A2A"/>
							</svg>
						}
					</span>
				</div>
				{ 
					open ? 
						<div className="flex w-full pt-[10px] pb-[40px] border-b border-solid border-[#eaeaeae6]">
							{children}
						</div> :
						null
				}
		</div>
	)
}
